import { createMemoryHistory } from 'history';

const history = createMemoryHistory({
  initialEntries: ['/'],
});

export default history;
